import React, { useImperativeHandle, forwardRef,useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row, Tooltip } from "reactstrap";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import axios from "axios";
import { Message } from 'primereact/message';
import { useForm, Controller } from 'react-hook-form';
import { triggerAlert } from "utils/CommonFunctions";

// Inside your component
const NotesContact = forwardRef(({ uniqueUserId, customers }, ref) => {
    const { control, handleSubmit, reset, setValue, formState: { errors } } = useForm({
    defaultValues: {
        contact: [],
        notes: ''
    }
});
    const [visibleLinkJob, setVisibleLinkJob] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');
    const [popchecked, setPopchecked] = useState(false);

 // Expose this method to the parent
  useImperativeHandle(ref, () => ({
    openLinkJobModal: () => setVisibleLinkJob(true),
  }));

  
    const handleIconClick = () => {
        setJobDetailsVisible(true);
    };

    const handleSave = () => {
    setJobDetailsVisible(false);
};

    const handleRefresh = () => {
    setSelectedJobs([]);
    setSearchText('');
    setValue('contact', [], { shouldValidate: true });
};

    const onSubmit = async (data) => {
    try {
        const response = await axios.post('/api/v1/notes/', {
            contact_id: data.contact?.map(job => job?.id).join(','),
            notes: data?.notes
        });
        console.log('Note created:', response.data);
        clearFields();
        setVisibleLinkJob(false);
        triggerAlert('success', 'Success', 'Note added successfully!');
    } catch (error) {
        console.error('Error creating note:', error);
        triggerAlert('error', 'Error', 'Failed to add note');
    }
};

    const clearFields = () => {
    setSelectedJobs([]);
    setSelectedJobTitles('');
    setSearchText('');
    setPopchecked(false);
    reset({
        contact: [],
        notes: ''
    });
};

    const handlePopupCheckbox = e => {
        setPopchecked(e.checked);
    };

    useEffect(() => {
    setValue('contact', selectedJobs, { shouldValidate: jobDetailsVisible || selectedJobs.length > 0 });
    const titles = selectedJobs
        ?.map((job) => `${job?.first_name || ""} ${job?.middle_name || ''} ${job?.last_name || ""} (${job?.job_title || ""})`.trim())
        .join(', ');
    setSelectedJobTitles(titles);
}, [selectedJobs, setValue, jobDetailsVisible]);

    return (
        <React.Fragment>
            <Tooltip target=".notes" content="Contacts Notes" position="bottom" style={{ marginTop: "5px" }} />
            <button
                type="button"
                className="btn btn-secondary icons-btn me-1 notes"
                onClick={() => setVisibleLinkJob(true)}
            >
                <i className="pi pi-file"></i>
            </button>

            <Dialog header={`Note - ${selectedJobTitles}`} visible={visibleLinkJob} onHide={() => { clearFields(); setVisibleLinkJob(false); }} style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg={6}>
                            <div className="field">
                                <label htmlFor="type" className="block mb-0">Type</label>
                                <InputText id="type" value="Note" readOnly className="w-full" disabled />
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="field">
                                <label htmlFor="currentDateTime" className="block mb-0">Date</label>
                                <Calendar id="currentDateTime" value={currentDateTime} onChange={(e) => setCurrentDateTime(e.value)} showTime showIcon dateFormat="yy-mm-dd" hourFormat="12" readOnlyInput className="w-full" />
                            </div>
                        </Col>

                        <Col lg={12}>
                            <div className="field">
                                <label htmlFor="job" className="block mb-0">Contact</label>
                                <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                    <Controller
    name="contact"
    control={control}
    rules={{ validate: value => value.length > 0 || 'Please select at least one contact.' }}
    render={({ field }) => (
        <InputText
            id="contact"
            value={selectedJobTitles}
            placeholder="Select Contact"
            className="w-full"
            style={{ paddingRight: '2rem' }}
            readOnly
        />
    )}
/>
                                    <i
                                        className="pi pi-chevron-down"
                                        onClick={handleIconClick}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                    ></i>
                                </div>
                                {errors.contact && <Message severity="error" text={errors.contact.message} className="mt-2" />}
                                
                                <Dialog
                                    header="Contact Details"
                                    visible={jobDetailsVisible}
                                    onHide={() => setJobDetailsVisible(false)}
                                    style={{ width: '40vw' }}
                                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                    className="cand-details"
                                >
                                    <Row>
                                        <Col lg={12}>
                                            <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                                <InputText placeholder="Search Contacts" value={searchText} onInput={(e) => setSearchText(e.target.value)} style={{ paddingRight: '2rem' }} />
                                                <i className="pi pi-search" style={{ position: 'absolute', right: '10px', top: '49%', transform: 'translateY(-50%)' }}></i>
                                            </div>
                                        </Col>
                                    </Row>

                                    <DataTable
    value={customers ? customers?.filter(customer => {
        const firstName = customer?.first_name || '';
        const middleName = customer?.middle_name || '';
        const lastName = customer?.last_name || '';
        const fullName = `${firstName} ${middleName} ${lastName}`.trim();
        return fullName.toLowerCase().includes(searchText?.toLowerCase() || '');
    }) : []}
    paginator
    rows={5}
    selection={selectedJobs}
    onSelectionChange={(e) => setSelectedJobs(e.value)}
    dataKey="id"
    rowsPerPageOptions={[5, 10, 25]}
    size="small"
>
                                        <Column selectionMode="multiple" style={{ width: '3em' }} />
                                        {/* <Column field="id" header="Contact ID" /> */}
                                        <Column header="Contact Title" body={(rowData) => {
                                            const firstName = rowData?.first_name || '';
                                            const middleName = rowData?.middle_name || '';
                                            const lastName = rowData?.last_name || '';
                                            return `${firstName} ${middleName} ${lastName}`.replace(/\s+/g, ' ').trim();
                                        }} />
                                        <Column field="email" header="Email" />
                                    </DataTable>

                                    {selectedJobs.length > 0 && (
                                        <div className="d-flex mt-3">
                                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                            <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                        </div>
                                    )}
                                </Dialog>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <div className="field">
                                <label htmlFor="notes" className="block mb-0">Notes</label>
                                <Controller
                                    name="notes"
                                    control={control}
                                    rules={{ required: 'Notes are required.' }}
                                    render={({ field }) => (
                                        <InputTextarea
                                            id="notes"
                                            {...field}
                                            rows={3}
                                            cols={20}
                                            className="w-full"
                                            placeholder="Enter your notes here..."
                                            autoResize
                                        />
                                    )}
                                />
                                {errors.notes && <Message severity="error" text={errors.notes.message} />}
                            </div>
                        </Col>
                    </Row>

                    <Row className="align-items-center">
                        <Col lg={2}>
                            <div className="d-flex align-items-center">
                                <Checkbox inputId="checkbox" checked={popchecked} onChange={handlePopupCheckbox} />
                                <label htmlFor="checkbox" className="ms-2 mt-2">Private</label>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="field notes-chip">
                                <label htmlFor="userId" className="block mb-0">User IDs</label>
                                <InputText value={uniqueUserId} readOnly className="w-full" />
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-primary me-2 btn-main">Add Note</button>
                            </div>
                        </Col>
                    </Row>
                </form>
            </Dialog>
        </React.Fragment>
    );
});

export default NotesContact;
